import axios from 'axios'

export default {
  state: {
    statistic: {},
  },
  getters: {
    getStatistic: (s) => s.statistic,
  },
  mutations: {
    setStatistic: (s, list) => (s.statistic = list),
  },
  actions: {
    fetchStatistic(ctx) {
      return axios({
        method: 'GET',
        url: `api/v3/statistic/progress`,
      })
        .then((response) => {
          const list = response.data
          ctx.commit('setStatistic', list)
        })
        .catch((error) => {
          console.error(error)
        })
    },
  },
}
